<template>
  <div class="add-driver my-2">
    <b-button v-b-modal.assign-ad-modal>Assign Ad</b-button>

    <b-modal id="assign-ad-modal" title="Assign Ad" hide-footer>
      <label class="typo__label">Please choose an ad</label>
      <multiselect
        v-model="value"
        :options="availableCampaigns"
        :custom-label="nameWithLang"
        label="name"
        track-by="_id"
      ></multiselect>
      <b-button class="my-5 float-right" @click="assignAd">
        <span v-if="assigning"> Assigning Ad...</span>
        <span v-else> Assign Ad </span>
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { campaigns } from "@/config/api/campaigns";

export default {
  props: ["vehicleId", "id", "availableCampaigns"],
  components: {
    Multiselect,
  },

  data() {
    return {
      value: null,
      assigning: false,
    };
  },
  created() {},

  methods: {
    assignAd() {
      if (!this.value) {
        this.$bvToast.toast("Please choose atleast one ad!", {
          title: "Assign Ad",
          variant: "danger",
          solid: true,
        });
        return;
      }
      this.assigning = true;
      const api = campaigns.assignDriver;
      const data = {
        campaignId: this.value._id,
        vehicleId: [this.vehicleId],
      };

      api.data = data;

      this.generateAPI(api)
        .then(() => {
          this.$bvToast.toast("Ad is added successfully", {
            title: "Assign Ad",
            variant: "success",
            solid: true,
          });
          this.$bvModal.hide("assign-ad-modal");
          this.$emit("reload");
        })
        .catch((err) => {
          this.$bvToast.toast(`As is not added, ${err.response.data.error}!`, {
            title: "Assign As",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.assigning = false;
        });
    },

    nameWithLang({
      company,
      start_within,
      no_of_drivers_required,
      no_of_drivers_assigned,
      campaign_name,
    }) {
      return `${campaign_name || "Not Provided"} - ${
        company.name
      } (start within:${this.moment(start_within).format(
        "LL"
      )}) - ${no_of_drivers_assigned} out of ${no_of_drivers_required}`;
    },
  },
};
</script>

<style></style>
